import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-piggy-bank-fill" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center col-md-6 col-sm-12" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "dropdown d-flex align-items-center" }
const _hoisted_12 = {
  href: "javascript:;",
  class: "dropdown-toggle middle-link",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_13 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_16 = { class: "setting-data" }
const _hoisted_17 = { class: "row align-items-center" }
const _hoisted_18 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_19 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "table" }
const _hoisted_22 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_23 = { class: "d-block my-3" }
const _hoisted_24 = { class: "d-none d-md-block" }
const _hoisted_25 = { class: "d-none t-d-md-table-cell" }
const _hoisted_26 = { class: "d-none t-d-md-table-cell" }
const _hoisted_27 = { class: "d-none t-d-md-table-cell" }
const _hoisted_28 = { class: "d-none t-d-md-table-cell" }
const _hoisted_29 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_30 = { class: "d-none t-d-md-table-cell" }
const _hoisted_31 = { class: "d-none t-d-md-table-cell" }
const _hoisted_32 = { class: "d-none t-d-md-table-cell" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { colspan: "9" }
const _hoisted_36 = { class: "text-center py-2" }
const _hoisted_37 = { class: "d-none d-md-block" }
const _hoisted_38 = ["onClick", "title"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_40 = {
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_41 = { style: {"padding":"5px 0"} }
const _hoisted_42 = { class: "bold" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_45 = { style: {"padding":"5px 0"} }
const _hoisted_46 = { class: "bold" }
const _hoisted_47 = { style: {"padding":"5px 0"} }
const _hoisted_48 = { class: "bold" }
const _hoisted_49 = { style: {"padding":"5px 0"} }
const _hoisted_50 = { class: "bold" }
const _hoisted_51 = { style: {"padding":"5px 0"} }
const _hoisted_52 = { class: "bold" }
const _hoisted_53 = { style: {"padding":"5px 0"} }
const _hoisted_54 = { class: "bold" }
const _hoisted_55 = { style: {"padding":"5px 0"} }
const _hoisted_56 = { class: "bold" }
const _hoisted_57 = { style: {"padding":"5px 0"} }
const _hoisted_58 = { class: "bold" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { style: {"padding":"5px 0"} }
const _hoisted_61 = { class: "bold" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_65 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_69 = ["onClick"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-checklist" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-credit-card-2-front-fill" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-shop-window" }, null, -1)
const _hoisted_73 = ["onClick"]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock-fill" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_76 = ["onClick"]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_78 = { class: "d-none t-d-md-table-cell" }
const _hoisted_79 = { class: "d-none t-d-md-table-cell" }
const _hoisted_80 = { class: "d-none t-d-md-table-cell" }
const _hoisted_81 = { class: "d-none t-d-md-table-cell" }
const _hoisted_82 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_83 = { class: "d-none t-d-md-table-cell" }
const _hoisted_84 = { class: "d-none t-d-md-table-cell" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { class: "d-none t-d-md-table-cell" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { class: "d-none t-d-md-table-cell" }
const _hoisted_89 = { class: "sett-small-menu align-right" }
const _hoisted_90 = { class: "discl-menu dropdown" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_92 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_93 = ["onClick"]
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { key: 0 }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = { key: 1 }
const _hoisted_99 = ["onClick"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-checklist" }, null, -1)
const _hoisted_101 = { key: 2 }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-credit-card-2-front-fill" }, null, -1)
const _hoisted_103 = { key: 3 }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-shop-window" }, null, -1)
const _hoisted_105 = { key: 4 }
const _hoisted_106 = ["onClick"]
const _hoisted_107 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock-fill" }, null, -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_109 = ["onClick"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_111 = { class: "col-md-6 col-sm-12" }
const _hoisted_112 = { class: "area-info" }
const _hoisted_113 = { class: "col-md-6 col-sm-12" }
const _hoisted_114 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_RefundOperModal = _resolveComponent("RefundOperModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.sales_refunds), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.selectedMonthLabel), 1),
                    _createElementVNode("ul", _hoisted_13, [
                      _createElementVNode("li", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfMonths, (oMonth) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: _normalizeClass(["dropdown-item", {'active': oMonth.id == _ctx.selectedMonth}]),
                            href: "javascript:;",
                            key: oMonth.id,
                            onClick: ($event: any) => (_ctx.changeMonth(oMonth.id))
                          }, _toDisplayString(oMonth.label), 11, _hoisted_14))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.list_of_refund_msg), 1),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.language.sales_refunds), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addSalesRefundRecord(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.lstOfSalesRefundsInfo.length == 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printListItems()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_20),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshList()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_21, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.language.sales_refunds), 1)
                    ]),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.language.refund_nbr), 1)
                  ]),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.language.order_nbr), 1),
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.language.date), 1),
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.language.customer), 1),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.language.staff), 1),
                  _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.language.total_amt), 1),
                  _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.language.refund_status), 1),
                  _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.language.payt_status), 1),
                  _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.language.stock_status), 1),
                  _hoisted_33
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.lstOfSalesRefundsInfo.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                      _createElementVNode("td", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPageElts, (salesRec) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: salesRec.SalesRefundRecord.IdRefund
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_37, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.addSalesRefundRecord(1, salesRec.SalesRefundRecord)),
                          title: _ctx.language.preview
                        }, _toDisplayString(salesRec.SalesRefundRecord.RefundNbr), 9, _hoisted_38),
                        _createTextVNode("  "),
                        _createVNode(_component_RouterLink, {
                          title: _ctx.language.details,
                          to: `/app/sales/refund/editor/${salesRec.SalesRefundRecord.RefundKey}`
                        }, {
                          default: _withCtx(() => [
                            _hoisted_39
                          ]),
                          _: 2
                        }, 1032, ["title", "to"])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.language.refund_nbr) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.addSalesRefundRecord(1, salesRec.SalesRefundRecord))
                            }, _toDisplayString(salesRec.SalesRefundRecord.RefundNbr), 9, _hoisted_43),
                            _createTextVNode("  "),
                            _createVNode(_component_RouterLink, {
                              title: _ctx.language.details,
                              to: `/app/sales/refund/editor/${salesRec.SalesRefundRecord.RefundKey}`
                            }, {
                              default: _withCtx(() => [
                                _hoisted_44
                              ]),
                              _: 2
                            }, 1032, ["title", "to"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.language.order_nbr) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, [
                            _createVNode(_component_RouterLink, {
                              to: `/app/sales/sales/editor/${salesRec.SalesOrderRecord.OrderKey}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(salesRec.SalesOrderRecord.OrderNbr), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.language.date) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatDate(salesRec.SalesRefundRecord.OperDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.language.customer) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(salesRec.CustomerRecord.ClientName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.language.staff) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(salesRec.Staff.FirstName + ' ' + salesRec.Staff.LastName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.language.total_amt) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesRec.TotalAmt)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.language.refund_status) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getOrderStatus(salesRec.SalesRefundRecord.RefundStatus)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.language.payt_status) + ":", 1),
                          _createTextVNode("  "),
                          (salesRec.SalesRefundRecord.RefundStatus == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.getPaytStatus(salesRec.PaytStatus)), 1))
                            : _createCommentVNode("", true),
                          (salesRec.SalesRefundRecord.RefundStatus != 0)
                            ? (_openBlock(), _createBlock(_component_RouterLink, {
                                key: 1,
                                to: `/app/sales/refund/payts/${salesRec.SalesRefundRecord.RefundKey}/list`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getPaytStatus(salesRec.PaytStatus)), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.language.refund_status) + ":", 1),
                          _createTextVNode("  "),
                          (salesRec.SalesRefundRecord.RefundStatus == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.getDeliveryStatus(salesRec.DeliveryStatus)), 1))
                            : _createCommentVNode("", true),
                          (salesRec.SalesRefundRecord.RefundStatus != 0)
                            ? (_openBlock(), _createBlock(_component_RouterLink, {
                                key: 1,
                                to: `/app/sales/refund/entries/${salesRec.SalesRefundRecord.RefundKey}/list`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getDeliveryStatus(salesRec.DeliveryStatus)), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_63, [
                          _hoisted_64,
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.addSalesRefundRecord(1, salesRec.SalesRefundRecord))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_66),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteSalesRefund(salesRec.SalesRefundRecord))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_67),
                            (salesRec.SalesRefundRecord.RefundStatus != 2)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_68))
                              : _createCommentVNode("", true),
                            (salesRec.SalesRefundRecord.RefundStatus == 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.confirmSalesRefund(salesRec.SalesRefundRecord))
                                }, [
                                  _hoisted_70,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.confirm), 1)
                                ], 8, _hoisted_69))
                              : _createCommentVNode("", true),
                            (salesRec.SalesRefundRecord.RefundStatus == 1 && salesRec.PaytStatus < 2)
                              ? (_openBlock(), _createBlock(_component_RouterLink, {
                                  key: 2,
                                  to: `/app/sales/refund/payts/${salesRec.SalesRefundRecord.RefundKey}/list`,
                                  class: "dropdown-item py-2"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_71,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.view_payments), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true),
                            (salesRec.SalesRefundRecord.RefundStatus == 1 && salesRec.DeliveryStatus < 2)
                              ? (_openBlock(), _createBlock(_component_RouterLink, {
                                  key: 3,
                                  to: `/app/sales/refund/entries/${salesRec.SalesRefundRecord.RefundKey}/list`,
                                  class: "dropdown-item py-2"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_72,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.stock_entry), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.isCompleteReady(salesRec))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 4,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.completeOrder(salesRec.SalesRefundRecord))
                                }, [
                                  _hoisted_74,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.lock), 1)
                                ], 8, _hoisted_73))
                              : _createCommentVNode("", true),
                            _hoisted_75,
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.printOneRefundNote(salesRec))
                            }, [
                              _hoisted_77,
                              _createTextVNode(" " + _toDisplayString(_ctx.language.print_refund_note), 1)
                            ], 8, _hoisted_76)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_78, [
                      _createVNode(_component_RouterLink, {
                        to: `/app/sales/sales/editor/${salesRec.SalesOrderRecord.OrderKey}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(salesRec.SalesOrderRecord.OrderNbr), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.appFxs.formatDate(salesRec.SalesRefundRecord.OperDate)), 1),
                    _createElementVNode("td", _hoisted_80, _toDisplayString(salesRec.CustomerRecord.ClientName), 1),
                    _createElementVNode("td", _hoisted_81, _toDisplayString(salesRec.Staff.FirstName + ' ' + salesRec.Staff.LastName), 1),
                    _createElementVNode("td", _hoisted_82, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesRec.TotalAmt)), 1),
                    _createElementVNode("td", _hoisted_83, _toDisplayString(_ctx.getOrderStatus(salesRec.SalesRefundRecord.RefundStatus)), 1),
                    _createElementVNode("td", _hoisted_84, [
                      (salesRec.SalesRefundRecord.RefundStatus == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(_ctx.getPaytStatus(salesRec.PaytStatus)), 1))
                        : _createCommentVNode("", true),
                      (salesRec.SalesRefundRecord.RefundStatus != 0)
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 1,
                            to: `/app/sales/refund/payts/${salesRec.SalesRefundRecord.RefundKey}/list`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getPaytStatus(salesRec.PaytStatus)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_86, [
                      (salesRec.SalesRefundRecord.RefundStatus == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString(_ctx.getDeliveryStatus(salesRec.DeliveryStatus)), 1))
                        : _createCommentVNode("", true),
                      (salesRec.SalesRefundRecord.RefundStatus != 0)
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 1,
                            to: `/app/sales/refund/entries/${salesRec.SalesRefundRecord.RefundKey}/list`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getDeliveryStatus(salesRec.DeliveryStatus)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("span", _hoisted_90, [
                          _hoisted_91,
                          _createElementVNode("ul", _hoisted_92, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.addSalesRefundRecord(1, salesRec.SalesRefundRecord))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                              ], 8, _hoisted_93)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.deleteSalesRefund(salesRec.SalesRefundRecord))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                              ], 8, _hoisted_94)
                            ]),
                            (salesRec.SalesRefundRecord.RefundStatus != 2)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_95, _hoisted_97))
                              : _createCommentVNode("", true),
                            (salesRec.SalesRefundRecord.RefundStatus == 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_98, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.confirmSalesRefund(salesRec.SalesRefundRecord))
                                  }, [
                                    _hoisted_100,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.confirm), 1)
                                  ], 8, _hoisted_99)
                                ]))
                              : _createCommentVNode("", true),
                            (salesRec.SalesRefundRecord.RefundStatus == 1 && salesRec.PaytStatus < 2)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_101, [
                                  _createVNode(_component_RouterLink, {
                                    class: "dropdown-item py-2",
                                    to: `/app/sales/refund/payts/${salesRec.SalesRefundRecord.RefundKey}/list`
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_102,
                                      _createTextVNode(" " + _toDisplayString(_ctx.language.view_payments), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              : _createCommentVNode("", true),
                            (salesRec.SalesRefundRecord.RefundStatus == 1 && salesRec.DeliveryStatus < 2)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_103, [
                                  _createVNode(_component_RouterLink, {
                                    to: `/app/sales/refund/entries/${salesRec.SalesRefundRecord.RefundKey}/list`,
                                    class: "dropdown-item py-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_104,
                                      _createTextVNode(" " + _toDisplayString(_ctx.language.stock_entry), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isCompleteReady(salesRec))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_105, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.completeOrder(salesRec.SalesRefundRecord))
                                  }, [
                                    _hoisted_107,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.lock), 1)
                                  ], 8, _hoisted_106)
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_108,
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.printOneRefundNote(salesRec))
                              }, [
                                _hoisted_110,
                                _createTextVNode(" " + _toDisplayString(_ctx.language.print_refund_note), 1)
                              ], 8, _hoisted_109)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.lstOfSalesRefundsInfo.length==0}])
            }, [
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("div", _hoisted_112, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.lstOfSalesRefundsInfo.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("nav", _hoisted_114, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredRecordItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_RefundOperModal, {
        visible: _ctx.isSalesRefundVis,
        initialValues: _ctx.salesRefundData,
        recordStatus: _ctx.salesRefundStatus,
        listOfUsers: _ctx.listOfUsers,
        listOfCustomers: _ctx.listOfCustomers,
        selectedMonth: _ctx.selectedMonth,
        onCloseForm: _ctx.onDetailClose
      }, null, 8, ["visible", "initialValues", "recordStatus", "listOfUsers", "listOfCustomers", "selectedMonth", "onCloseForm"])
    ]))
  ], 64))
}